import localeAntd from 'ant-design-vue/lib/locale-provider/pt_PT'

const messages = {
    topBar: {
        issuesHistory: 'Tarefas',
        projectManagement: 'Projeto',
        typeToSearch: 'Pesquisa...',
        findPages: 'Encontrar páginas...',
        actions: 'Ações',
        status: 'Estado',
        profileMenu: {
            hello: 'Olá',
            billingPlan: 'Plano de faturação',
            role: 'Uni. Org.',
            email: 'Email',
            nif: 'Nif',
            phone: 'Telemóvel',
            editProfile: 'Editar perfil',
            logout: 'Logout',
        },
    },
}

export default {
    locale: 'pt-PT',
    localeAntd,
    messages,
}
